export default {
    url: '/add',
    template: '<survey-add forms="vm.forms" company="vm.company" survey-group="vm.surveyGroup"></survey-add>',
    resolve: {
        forms (FormResource, FORMS_TYPE_ENUM, ROLE_COMPANY_MODULE_PRIVILEGE_ENUM) {
            return FormResource.query({
                type: FORMS_TYPE_ENUM.KEYS.SURVEY,
                'privileges[]': [ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.FORMS_SURVEY_MANAGE]
            }).$promise;
        },
        company (CompanyResource, TokenService) {
            return CompanyResource.publicView({ id: TokenService.getCompanyId(), expand: 'companySurveyI18ns' }).$promise;
        }
    },
    controller (forms, company, SurveyGroupResource) {
        this.forms = forms;
        this.company = company;
        this.surveyGroup = new SurveyGroupResource();
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/survey/add/index.js